import React, { Suspense } from 'react'
import { Redirect, Route, Switch } from 'react-router-dom'
import LazyRoutes from 'src/routes/LazyRoutes'
import Loading from 'src/Components/shared/Loading/LoadingApp'

const HOME_DIR = 'home'

const PreviewRoutes = ({ rootDir }) => (
  <Suspense fallback={<Loading />}>
    <Switch>
      <Route path={`${rootDir}/${HOME_DIR}`} component={LazyRoutes.Preview} />
      <Redirect to='/' />
    </Switch>
  </Suspense>
)

export default PreviewRoutes
